export const gtm1Marketing = {
  eventMarketingBannerActionHandler ({ data }) {
    const {
      screenName,
      pageSource,
      eventAction,
      bannerVariant,
      loanProvider,
    } = data

    return {
      event: 'Marketing_Banner_Action',
      properties: {
        screen_name: screenName,
        page_source: pageSource,
        event_action: eventAction,
        banner_variant: bannerVariant || null,
        loan_provider: loanProvider,
      },
    }
  },
}
